import { Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import AdminsPage from "./pages/AdminsPage";
import CategoriesPage from "./pages/CategoriesPage";
import CustomersPage from "./pages/CustomersPage";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import NoMatch from "./pages/NoMatch";
import OrdersPage from "./pages/orders/OrdersPage";
import ProductsPage from "./pages/ProductsPage";
import ShowOrder from "./pages/orders/ShowOrder";
import CreateOrder from "./pages/orders/CreateOrder";
import AboutThisProjectPage from "./pages/AboutThisProjectPage";

function App() {
  return (
    <div className="position-relative h-100">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/admins" element={<AdminsPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/showorder/:orderId" element={<ShowOrder />} />
          <Route path="/createorder" element={<CreateOrder />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route
            path="/about-this-project"
            element={<AboutThisProjectPage />}
          />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
